import bootStrap, { setViewTitle } from 'counselor-sdk'

import {
  // CPDAILY,
  SCRIPT,
} from 'counselor-sdk/lib/config/platform'
import {
  hideGlobalLoading,
  showGlobalLoading,
} from 'counselor-mobile-ui/utils/ui/loading'

import {
  handleDestroyOverlayComponent,
  handleResetLoading,
} from 'counselor-mobile-ui/utils/vue/router'
import {
  isIOS,
  isWxPlatform,
  isWxWorkPlatform,
} from 'counselor-mobile-ui/utils/feature/platform'
import { getUrlParams } from 'counselor-mobile-ui/utils/feature/helper'
import inobounce from 'inobounce'

const CPDAILY = 'wisedu'.toUpperCase() //
SCRIPT[CPDAILY] = 'https://static.campushoy.com/sjctemp/innerjs-harmonyos-test/innerjs-harmonyos/campus.js'

export const initSdk = (router, queryConfig) => {
  router.beforeEach(async (to, from, next) => {
    handleDestroyOverlayComponent(to, from)
    handleResetLoading(to, from)
    const urlParams = getUrlParams()

    if (isWxPlatform() || isWxWorkPlatform()) {
      if (urlParams.detail) {
        const newSearch = window.location.search.replace(/detail=true/, '')
        let newHash = ''

        if (urlParams.needApproval === '0' || urlParams.needApproval === 0) {
          newHash = `#/detail/${urlParams.id}/0`
        } else {
          newHash = `#/detail/${urlParams.id}/1`
        }

        window.location.href = window.location.origin + window.location.pathname + newSearch + newHash
      }
    }

    if (to.meta.useSdk) {
      showGlobalLoading()

      const CPDAILY = 'wisedu'.toUpperCase() // 今日校园
      const data = await bootStrap(queryConfig, {
        scriptResolver: {
          [CPDAILY]: 'https://static.campushoy.com/sjctemp/innerjs-harmonyos-test/innerjs-harmonyos/campus.js'
        }
      })

      hideGlobalLoading()
      if (data.code === 0) {
        setViewTitle({ title: to.meta.title })
        if (isIOS) {
          inobounce.enable()
        }

        next()
      } else {
        if (isIOS) {
          inobounce.enable()
        }

        next(process.env.NODE_ENV === 'development' ? true : { path: '/page-empty' })
      }
    } else {
      if (isIOS) {
        inobounce.enable()
      }

      next()
    }
  })

  router.afterEach(async (to, from) => {
    if (isIOS) {
      inobounce.disable()
    }
  })
}
